import { GroupWork, VerifiedUserSharp } from "@material-ui/icons";
import React from "react";
import { useHistory } from "react-router";
import "./Skills.css";

function Skills() {
  const history = useHistory();
  return (
    <div className="skills">
      <div
        className="skills__allSkills"
        onClick={() => history.push("/Skills/list")}
      >
        <GroupWork style={{ fontSize: 100 }} />
        <p style={{ margin: "20px 0", fontSize: 20 }}>All Skills</p>
      </div>
      <div
        className="skills__approvals"
        onClick={() => history.push("/Skills/approvals")}
      >
        <VerifiedUserSharp style={{ fontSize: 100 }} />
        <p style={{ margin: "20px 0", fontSize: 20 }}>Approvals Pending</p>
      </div>
    </div>
  );
}

export default Skills;
